import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';
import * as PricelistDetailModels from '../../models/pricelist-detail/pricelist-detail';
import { PricelistDetailSearchModel } from '../../models/pricelist-detail/pricelist-detailSearch';
import { EnvironmentService } from '../../../app/services/environment.service';
import { TooltipModel } from '../../models/tooltip';
import { ResponseBase } from '../../models/commonModels';

@Injectable({
  providedIn: 'root'
})
export class PricelistDetailService {

constructor(private httpClient: HttpClient,
            private environmentService: EnvironmentService) { }


 public get(Search: PricelistDetailSearchModel) {
    const httpHeaders = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Cache-Control', 'no-cache');

    Search.RequestSignature = Math.random();

    const options = { headers: httpHeaders };
    return this.httpClient.post<PricelistDetailModels.PricelistDetailListModel>(
      `${this.environmentService.getApiURL()}/pricelist/detail/list`, Search, options);
  }

  public setPricelistDetail(PricelistDetail: PricelistDetailModels.PricelistDetailModel) {
    const httpHeaders = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Cache-Control', 'no-cache');

    const options = {headers: httpHeaders};

    return this.httpClient.post<PricelistDetailModels.PricelistDetailModel>(
      `${this.environmentService.getApiURL()}/pricelist/detail/set`, PricelistDetail, options);
  }

  public deletePricelistDetail(PricelistDetail: PricelistDetailModels.PricelistDetailModel) {
    const httpHeaders = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Cache-Control', 'no-cache');

    const options = {headers: httpHeaders};

    return this.httpClient.post<PricelistDetailModels.PricelistDetailModel>(
      `${this.environmentService.getApiURL()}/pricelist/detail/delete`, PricelistDetail, options);
  }

  public insertNew(PricelistNewDetail: PricelistDetailModels.PricelistDetailInsertModel) {
    const httpHeaders = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Cache-Control', 'no-cache');

    const options = {headers: httpHeaders};
    return this.httpClient.post<PricelistDetailModels.PricelistDetailModel>(
      `${this.environmentService.getApiURL()}/pricelist/detail/insert`, PricelistNewDetail, options);
  }


 public importPricelist(formData: FormData) {
    const httpHeaders = new HttpHeaders()
    .set('Content-Type', 'multipart/form-data')
    .set('Accept', 'application/json');
    const options = {headers: httpHeaders};

    // tslint:disable-next-line: max-line-length
    return this.httpClient.post<PricelistDetailModels.PricelistDetailImportResponse>(
      `${this.environmentService.getApiURL()}/pricelist/detail/import`, formData);
  }


}
